import { useState } from "react";
import { formatPrice } from "../../helpers/formatHelper";
import './walletButton.scss';
import { Savings } from "@mui/icons-material";

interface WalletButtonProps {
  walletBalance: number;
  totalAmount: number;
  onToggle: (selected: boolean) => void;
  disabled: boolean
}

const WalletButton = ({ walletBalance, totalAmount, onToggle, disabled }: WalletButtonProps) => {
  const [selected, setSelected] = useState(true);

  const remainingAmount = selected ? Math.max(totalAmount - walletBalance, 0) : totalAmount;

  const handleClick = () => {
    setSelected(!selected);
    onToggle(!selected);
  };

  return (
    <div className="container">
      <button 
        type="button" 
        className={`wallet-btn ${selected ? 'selected' : ''}`} 
        onClick={handleClick}
        disabled={disabled}
      >
        <div className="wallet-btn-content">
          <Savings className="wallet-icon" fontSize="large" />
          <div className="wallet-info">
            <div className="wallet-balance">Wallet: {formatPrice(walletBalance)}</div>
            <div className="wallet-remaining">You will pay: {formatPrice(remainingAmount)}</div>
          </div>
        </div>
      </button>
    </div>
  );
};

export default WalletButton;